import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Vitals.css';
import WebService from "../../../services/webservice";
import { useNavigate   } from 'react-router-dom';

const Vitals = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${WebService}api/vitals-dashboard-data`);
        setData(response.data);
      } catch (error) {
        console.error('Error fetching vitals data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="vitals-loading">Loading Vitals Dashboard...</div>;
  }

  return (
    <div className="vitals-dashboard">
      <h1 className="vitals-header">Vitals Overview</h1>
      <div className="vitals-cards-container">
        {/* Blood Sugar Card */}
        {data && data.bloodSugar && (
        <div className="vitals-card blood-sugar" onClick={() => navigate('/blood-sugar-report')}>
          <div className="vitals-card-header">
            <span className="vitals-card-icon icon-blood" style={{ color: '#E91E63' }}>
              <i className="fa fa-tint" aria-hidden="true"></i>
            </span>
            <h2 className="vitals-card-title">Blood Sugar</h2>
          </div>
          <div className="vitals-stats-grid">
            <div className="vitals-stat-box">
               <div className="vitals-stat-label">Total Users</div>
               <div className="vitals-stat-value">{data.bloodSugar.totalUsers}</div>
            </div>
            <div className="vitals-stat-box">
               <div className="vitals-stat-label">Total Logs</div>
               <div className="vitals-stat-value">{data.bloodSugar.totalLogs}</div>
            </div>
          </div>

          <div className="vitals-status-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px 5px', alignItems: 'start' }}>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#5cb85c' }}></span>
              <span className="vitals-status-label">Low</span>
              <span className="vitals-status-percent">{data.bloodSugar.statuses.Low.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#20c997' }}></span>
              <span className="vitals-status-label">Normal</span>
              <span className="vitals-status-percent">{data.bloodSugar.statuses.Normal.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#f0ad4e' }}></span>
              <span className="vitals-status-label">Prediabetes</span>
              <span className="vitals-status-percent">{data.bloodSugar.statuses.Prediabetes.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#d9534f' }}></span>
              <span className="vitals-status-label">Diabetes</span>
              <span className="vitals-status-percent">{data.bloodSugar.statuses.Diabetes.percentage}%</span>
            </div>
          </div>
        </div>
        )}

         {/* Blood Pressure Card */}
        {data && data.bloodPressure && (
        <div className="vitals-card blood-pressure" onClick={()=>navigate('/blood-pressure-report')}>
          <div className="vitals-card-header">
            <span className="vitals-card-icon icon-bp" style={{ color: '#007bff' }}>
              <i className="fa fa-stethoscope" aria-hidden="true"></i>
            </span>
            <h2 className="vitals-card-title">Blood Pressure</h2>
          </div>
          <div className="vitals-stats-grid">
            <div className="vitals-stat-box">
               <div className="vitals-stat-label">Total Users</div>
               <div className="vitals-stat-value">{data.bloodPressure.totalUsers}</div>
            </div>
            <div className="vitals-stat-box">
               <div className="vitals-stat-label">Total Logs</div>
               <div className="vitals-stat-value">{data.bloodPressure.totalLogs}</div>
            </div>
          </div>
          
          <div className="vitals-status-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px 5px', alignItems: 'start' }}>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#28a745' }}></span>
              <span className="vitals-status-label">Normal</span>
              <span className="vitals-status-percent">{data.bloodPressure.statuses.Normal.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#007bff' }}></span>
              <span className="vitals-status-label">Elevated</span>
              <span className="vitals-status-percent">{data.bloodPressure.statuses.Elevated.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#fd7e14' }}></span>
              <span className="vitals-status-label">Stage 1</span>
              <span className="vitals-status-percent">{data.bloodPressure.statuses.Stage1.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#dc3545' }}></span>
              <span className="vitals-status-label">Stage 2</span>
              <span className="vitals-status-percent">{data.bloodPressure.statuses.Stage2.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#8b0000' }}></span>
              <span className="vitals-status-label">Crisis</span>
              <span className="vitals-status-percent">{data.bloodPressure.statuses.Crisis.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#6c757d' }}></span>
              <span className="vitals-status-label">Low</span>
              <span className="vitals-status-percent">{data.bloodPressure.statuses.Low.percentage}%</span>
            </div>
          </div>
        </div>
        )}
        
        {/* Body Temperature Card */}
        {data && data.bodyTemperature && (
        <div className="vitals-card body-temperature">
          <div className="vitals-card-header">
            <span className="vitals-card-icon icon-temp">
              <i className="fa fa-thermometer-half" aria-hidden="true"></i>
            </span>
            <h2 className="vitals-card-title">Body Temperature</h2>
          </div>
          <div className="vitals-stats-grid">
            <div className="vitals-stat-box">
               <div className="vitals-stat-label">Total Users</div>
               <div className="vitals-stat-value">{data.bodyTemperature.totalUsers}</div>
            </div>
            <div className="vitals-stat-box">
               <div className="vitals-stat-label">Total Logs</div>
               <div className="vitals-stat-value">{data.bodyTemperature.totalLogs}</div>
            </div>
          </div>
          
          <div className="vitals-status-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px 5px', alignItems: 'start' }}>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#87CEEB' }}></span>
              <span className="vitals-status-label">Mild hypothermia</span>
              <span className="vitals-status-percent">{data.bodyTemperature.statuses.MildHypothermia.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#32CD32' }}></span>
              <span className="vitals-status-label">Normal</span>
              <span className="vitals-status-percent">{data.bodyTemperature.statuses.Normal.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#FFD700' }}></span>
              <span className="vitals-status-label">Slightly elevated</span>
              <span className="vitals-status-percent">{data.bodyTemperature.statuses.SlightlyElevated.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#FFA500' }}></span>
              <span className="vitals-status-label">Fever</span>
              <span className="vitals-status-percent">{data.bodyTemperature.statuses.Fever.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#FF4500' }}></span>
              <span className="vitals-status-label">High fever</span>
              <span className="vitals-status-percent">{data.bodyTemperature.statuses.HighFever.percentage}%</span>
            </div>
            <div className="vitals-status-item">
              <span className="vitals-status-dot" style={{ backgroundColor: '#8B0000' }}></span>
              <span className="vitals-status-label">Hyperpyrexia</span>
              <span className="vitals-status-percent">{data.bodyTemperature.statuses.Hyperpyrexia.percentage}%</span>
            </div>
          </div>
        </div>
        )}

                {/* Heart Rate Card */}
        {data && data.heartRate && (
          <div className="vitals-card heart-rate">
            <div className="vitals-card-header">
              <span className="vitals-card-icon icon-heart">
                <i className="fa fa-heartbeat" aria-hidden="true"></i>
              </span>
              <h2 className="vitals-card-title">Heart Rate</h2>
            </div>

            <div className="vitals-stats-grid">
              <div className="vitals-stat-box">
                <div className="vitals-stat-label">Total Users</div>
                <div className="vitals-stat-value">{data.heartRate.totalUsers}</div>
              </div>
              <div className="vitals-stat-box">
                <div className="vitals-stat-label">Total Logs</div>
                <div className="vitals-stat-value">{data.heartRate.totalLogs}</div>
              </div>
            </div>

            <div className="vitals-status-row">
              <div className="vitals-status-item">
                <span className="vitals-status-dot dot-normal"></span>
                <span className="vitals-status-label">Normal</span>
                <span className="vitals-status-percent">{data.heartRate.statuses.Normal.percentage}%</span>
              </div>
              <div className="vitals-status-item">
                <span className="vitals-status-dot dot-high"></span>
                <span className="vitals-status-label">High</span>
                <span className="vitals-status-percent">{data.heartRate.statuses.High.percentage}%</span>
              </div>
              <div className="vitals-status-item">
                <span className="vitals-status-dot dot-low"></span>
                <span className="vitals-status-label">Low</span>
                <span className="vitals-status-percent">{data.heartRate.statuses.Low.percentage}%</span>
              </div>
            </div>
          </div>
        )}

        {/* Oxygen Saturation Card */}
        {data && data.oxygen && (
          <div className="vitals-card oxygen-saturation">
            <div className="vitals-card-header">
              <span className="vitals-card-icon icon-lungs">
                <i className="fa fa-lungs" aria-hidden="true"></i>
              </span>
              <h2 className="vitals-card-title">Oxygen Level</h2>
            </div>

            <div className="vitals-stats-grid">
              <div className="vitals-stat-box">
                <div className="vitals-stat-label">Total Users</div>
                <div className="vitals-stat-value">{data.oxygen.totalUsers}</div>
              </div>
              <div className="vitals-stat-box">
                <div className="vitals-stat-label">Total Logs</div>
                <div className="vitals-stat-value">{data.oxygen.totalLogs}</div>
              </div>
            </div>

            <div className="vitals-status-row">
              <div className="vitals-status-item">
                <span className="vitals-status-dot dot-normal"></span>
                <span className="vitals-status-label">Normal</span>
                <span className="vitals-status-percent">{data.oxygen.statuses.Normal.percentage}%</span>
              </div>
              <div className="vitals-status-item">
                <span className="vitals-status-dot dot-high"></span>
                <span className="vitals-status-label">High</span>
                <span className="vitals-status-percent">{data.oxygen.statuses.High.percentage}%</span>
              </div>
              <div className="vitals-status-item">
                <span className="vitals-status-dot dot-low"></span>
                <span className="vitals-status-label">Low</span>
                <span className="vitals-status-percent">{data.oxygen.statuses.Low.percentage}%</span>
              </div>
            </div>
          </div>
        )}


      </div>
    </div>
  );
};

export default Vitals;
